import { TableType } from '@app/pages/cmms/types';
import { IActionCenterDeleter } from '../../interfaces';
import { Injectable, inject } from '@angular/core';
import { FileDeleter } from './file-deleter';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { FilesService } from '@app/pages/cmms/services/files.service';
import { AssetDeleter } from './asset-deleter';
import { Apollo } from 'apollo-angular';
import { WoDeleter } from './work-order-deleter';
import { RequestDeleter } from './request-deleter';
import { IncidentDeleter } from './incident-deleter';

@Injectable({
	providedIn: 'root',
})
export class DeleterFactory {
	private readonly fileService = inject(FilesService);
	private readonly actionCenterService = inject(ActionCenterService);
	private readonly apollo = inject(Apollo);
	constructor() {}

	createDeleter(
		tableType:
			| TableType.FILES
			| TableType.ASSETS
			| TableType.WORK_ORDER
			| TableType.REQUESTS
			| TableType.INCIDENTS,
		openDeleteDialog?: (pks: string[], callback: (pks: string[]) => void) => void
	): IActionCenterDeleter | null {
		if (tableType === TableType.FILES) {
			return new FileDeleter(
				this.actionCenterService,
				this.fileService,
				openDeleteDialog
			);
		}

		if (tableType === TableType.ASSETS) {
			return new AssetDeleter(this.actionCenterService, this.apollo, openDeleteDialog);
		}

		if (tableType === TableType.WORK_ORDER) {
			return new WoDeleter(this.actionCenterService, this.apollo, openDeleteDialog);
		}

		if (tableType === TableType.REQUESTS) {
			return new RequestDeleter(this.actionCenterService, this.apollo, openDeleteDialog);
		}

		if (tableType === TableType.INCIDENTS) {
			return new IncidentDeleter(this.actionCenterService, this.apollo, openDeleteDialog);
		}

		return null;
	}
}
